/*
  topbarHardFix.js - VERSION ULTRA-ROBUSTE
  Ensure the 3 topbar buttons always open panels, NO MATTER WHAT.
  This script MUST load AFTER app.js and will OVERRIDE any conflicting handlers.
*/
(() => {
  'use strict';

  console.log('[TopbarFix] 🔧 Initialisation...');

  const $ = (id) => document.getElementById(id);
  let __justOpenedAt = 0;
  function markJustOpened(){ __justOpenedAt = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now(); }
  function justOpened(){
    const now = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
    return (now - (__justOpenedAt||0)) < 250;
  }

  function fallbackOpen(which) {
    console.log(`[TopbarFix] 📂 fallbackOpen("${which}") appelée`);
    markJustOpened();
    
    const overlay = $('panelOverlay');
    const titleEl = $('panelTitle');
    const logView = $('panelLog');
    const gameView = $('panelGame');
    const setupView = $('panelSetup');

    if (!overlay || !logView || !gameView || !setupView) {
      console.error('[TopbarFix] ❌ Éléments du panel manquants');
      return;
    }

    // Show overlay
    overlay.classList.add('open');
    // Match app.js behaviour: when a panel is open, the body gets a flag class.
    // Without this, closing via "click outside" can leave the UI blurred.
    try { document.body.classList.add('panelOpen'); } catch (_e) {}
    console.log('[TopbarFix] ✅ Overlay ouvert');

    // Hide all views first
    logView.hidden = true;
    gameView.hidden = true;
    setupView.hidden = true;

    // Show requested view
    let t = '';
    if (which === 'log') {
      logView.hidden = false;
      t = 'Journal';
      console.log('[TopbarFix] ✅ Vue LOG affichée');
    } else if (which === 'game') {
      gameView.hidden = false;
      t = 'Partie';
      console.log('[TopbarFix] ✅ Vue GAME affichée');
    } else {
      setupView.hidden = false;
      t = 'Connexion';
      console.log('[TopbarFix] ✅ Vue SETUP affichée');
    }

    if (titleEl) titleEl.textContent = t;
  }

  function fallbackClose() {
    console.log('[TopbarFix] 📪 fallbackClose() appelée');
    
    const overlay = $('panelOverlay');
    if (!overlay) return;
    overlay.classList.remove('open');
    // Ensure we always clear the body flag (fixes "blur stays" bug when closing by clicking outside).
    try { document.body.classList.remove('panelOpen'); } catch (_e) {}

    const logView = $('panelLog');
    const gameView = $('panelGame');
    const setupView = $('panelSetup');
    if (logView) logView.hidden = true;
    if (gameView) gameView.hidden = true;
    if (setupView) setupView.hidden = true;
    
    console.log('[TopbarFix] ✅ Panel fermé');
  }

  function open(which) {
    console.log(`[TopbarFix] 🎯 open("${which}") appelée`);
    
    // Try the "real" API first if it exists.
    try {
      if (typeof window.openPanel === 'function' && window.PANEL_VIEW) {
        console.log('[TopbarFix] ℹ️ window.openPanel trouvée, tentative d\'utilisation...');
        const view =
          which === 'log' ? window.PANEL_VIEW.LOG :
          which === 'game' ? window.PANEL_VIEW.GAME :
          window.PANEL_VIEW.SETUP;
        window.openPanel({ view, title: '', mode: 'drawer' });
        console.log('[TopbarFix] ✅ Panel ouvert via window.openPanel');
        return;
      }
    } catch (e) {
      console.warn('[TopbarFix] ⚠️ window.openPanel a échoué:', e.message);
    }
    
    console.log('[TopbarFix] ℹ️ Utilisation du fallback');
    fallbackOpen(which);
  }

  function wireBtn(btnId, which) {
    const btn = $(btnId);
    if (!btn) {
      console.error(`[TopbarFix] ❌ Bouton #${btnId} non trouvé`);
      return;
    }

    console.log(`[TopbarFix] 🔌 Configuration du bouton #${btnId} pour "${which}"`);

    const handler = (e) => {
      console.log(`[TopbarFix] 🖱️ Handler déclenché pour #${btnId} (type: ${e.type})`);
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation(); // CRUCIAL: stoppe TOUS les autres handlers
      open(which);
    };

    // CRUCIAL: D'abord, SUPPRIMER tout onclick existant
    btn.onclick = null;
    console.log(`[TopbarFix] 🧹 onclick supprimé pour #${btnId}`);

    // Ensuite, attacher NOS handlers avec capture=true pour être PREMIER
    btn.addEventListener('click', handler, { passive: false, capture: true });
    btn.addEventListener('pointerup', handler, { passive: false, capture: true });
    btn.addEventListener('touchend', handler, { passive: false, capture: true });
    
    // OVERRIDE: Redéfinir onclick pour pointer vers notre handler
    btn.onclick = handler;
    
    console.log(`[TopbarFix] ✅ Handlers attachés à #${btnId}`);
  }

  function init() {
    console.log('[TopbarFix] 🚀 init() démarrée');
    
    wireBtn('logBtn', 'log');
    wireBtn('midBtn', 'game');
    wireBtn('setupBtn', 'setup');

    // Ensure close works even if the normal close handler didn't attach.
    const closeBtn = $('panelClose');
    if (closeBtn) {
      const closeHandler = (e) => {
        console.log('[TopbarFix] ✕ Bouton fermer cliqué');
        e.preventDefault();
        e.stopPropagation();
        try {
          if (typeof window.closePanel === 'function') window.closePanel();
          else fallbackClose();
        } catch (_) {
          fallbackClose();
        }
      };
      closeBtn.onclick = closeHandler;
      closeBtn.addEventListener('pointerup', closeHandler, { passive: false });
      closeBtn.addEventListener('click', closeHandler, { passive: false });
      console.log('[TopbarFix] ✅ Bouton fermer configuré');
    } else {
      console.warn('[TopbarFix] ⚠️ Bouton fermer non trouvé');
    }

    const overlay = $('panelOverlay');
    if (overlay) {
      // Tap outside panel to close
      overlay.addEventListener('pointerdown', (e) => {
        if (justOpened()) return;
        if (e.target === overlay) {
          console.log('[TopbarFix] 🖱️ Clic en dehors du panel détecté');
          fallbackClose();
        }
      }, { passive: true });
      console.log('[TopbarFix] ✅ Clic extérieur configuré');
    } else {
      console.warn('[TopbarFix] ⚠️ Overlay non trouvé');
    }
    
    console.log('[TopbarFix] ✅ Initialisation terminée avec succès');
  }

  // CRUCIAL: Attendre que le DOM soit prêt ET que app.js ait fini
  function initWithDelay() {
    if (document.readyState === 'loading') {
      console.log('[TopbarFix] ⏳ DOM en cours de chargement, attente...');
      document.addEventListener('DOMContentLoaded', () => {
        console.log('[TopbarFix] ✅ DOMContentLoaded reçu');
        // Délai supplémentaire pour être SÛR que app.js a fini
        setTimeout(init, 100);
      }, { once: true });
    } else {
      console.log('[TopbarFix] ✅ DOM déjà chargé');
      // Délai pour être SÛR que app.js a fini
      setTimeout(init, 100);
    }
  }

  initWithDelay();
  
  // BACKUP: Si rien ne s'est passé après 2 secondes, forcer l'init
  setTimeout(() => {
    const logBtn = $('logBtn');
    if (logBtn && logBtn.onclick === null) {
      console.warn('[TopbarFix] ⚠️ Boutons toujours pas configurés après 2s, forçage...');
      init();
    }
  }, 2000);
})();